import React from 'react';
import { PropTypes } from 'prop-types';
import Promise from 'bluebird';
import { connect } from 'react-redux';
import { Videos } from 'api';
import CONFIG from 'base/constants/config';
import { ShowIf } from 'components/utils';

class VideoForm extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      "title": "",
      "linkId": ""
    }
  }

  bindData(data) {
    const {title, linkId} = data;

    this.setState({
      title, linkId
    })
  }

  onInputChange(name, e) {
    let value = e.target ? e.target.value : e;
    this.setState({
      [name]: value
    })
  }

  submitForm(e) {
    e.preventDefault();

    let params = {};

    let data = {
      ...this.state
    }

    if (this.props.data && typeof this.props.data.id != "undefined") {
      params = {id: this.props.data.id};
    }

    return this.props.dispatch(this.props.fnSubmit(params, {
      data
    }))
      .then(response => {

        if (typeof this.props.cb == 'function') {
          this.props.cb(response);
        }

        return Promise.resolve(response)
      })
      .catch(err => {
        Promise.reject(err);
      })
  }

  componentDidMount() {
    if (this.props.data) {
      this.bindData(this.props.data)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data != this.state.data) {
      this.bindData(nextProps.data);
    }
  }

  render() {
    return(
      <div>
        <form onSubmit={this.submitForm.bind(this)}>
        <div className="form-group">
            <label>Tiêu đề</label>
            <input type="text" className="form-control" value={this.state.title} placeholder="Tiêu đề" onChange={this.onInputChange.bind(this, 'title')}/>
          </div>
          <div className="form-group">
            <label>Liên kết Video</label>
            <input type="text" className="form-control" value={this.state.linkId} placeholder="http://" onChange={this.onInputChange.bind(this, 'linkId')}/>
          </div>

          <ShowIf condition={this.props.data}>
            <button type="submit" className="btn btn-primary btn-submit text-btn">Cập nhật Video</button>
          </ShowIf>
          <ShowIf condition={!this.props.data}>
            <button type="submit" className="btn btn-primary btn-submit text-btn">Thêm Video</button>
          </ShowIf>

          <button type='button' className="btn" onClick={() => this.props.history.push('/videos')}>Thoát</button>
        </form>
      </div>
    )
  }
}

const mapStateToProps = function(state) {
  return {

  }
}

VideoForm.propTypes = {
  fnSubmit: PropTypes.func.isRequired
}

VideoForm.contextTypes = {
  router: React.PropTypes.object
};

export default connect(mapStateToProps)(VideoForm);


// WEBPACK FOOTER //
// ./components/videos/VideoForm.jsx